import service from '@/store/services/tramos-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  listActive: {},
  tramo: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_LIST_ACTIVE: (state, listActive) => {
    state.listActive = listActive;
  },
  SET_RESOURCE: (state, tramo) => {
    state.tramo = tramo;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  listActive({ commit, dispatch }, params) {
    return service.listActive(params).then(({ listActive }) => {
      commit("SET_LIST_ACTIVE", listActive);
    });
  },

  get({commit, dispatch}, params) {
    return service.get(params, this.$axios)
      .then((tramo) => { commit('SET_RESOURCE', tramo); });
  },

  add({commit, dispatch}, params) {
    return service.add(params, this.$axios)
      .then((tramo) => { commit('SET_RESOURCE', tramo); });
  },

  update({commit, dispatch}, params) {
    return service.update(params, this.$axios)
      .then((tramo) => { commit('SET_RESOURCE', tramo); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params, this.$axios);
  },

  activate({commit, dispatch}, params) {
    return service.activate(params, this.$axios)
      .then((tramo) => { commit('SET_RESOURCE', tramo); });
  },

  deactivate({commit, dispatch}, params) {
    return service.deactivate(params, this.$axios)
      .then((tramo) => { commit('SET_RESOURCE', tramo); });
  },
};

const getters = {
  list: state => state.list,
  listActive: state => state.listActive,
  listTotal: state => state.meta.total, 
  tramo: state => state.tramo,
  url: state => state.url
};

const tramos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default tramos;
